import React, { forwardRef } from "react"
import { Icon, IconProps } from "@mui/material"
import { useStyles } from "./styles"
import { IconSize } from "./types"

interface Props extends IconProps {
  size?: IconSize
  solid?: boolean
  duotone?: boolean
  spin?: boolean
  pulse?: boolean
  name: string
}

const FaIcon: React.FC<Props> = forwardRef(
  ({ solid, duotone, spin, pulse, name, size = "small", ...props }, ref) => {
    const { classes, cx } = useStyles()

    return (
      <Icon
        ref={ref}
        {...props}
        className={cx(
          props.className,
          solid ? "fa-solid" : "fa-regular",
          duotone && "fa-duotone",
          spin && "fa-spin",
          pulse && "fa-pulse",
          `fa-${name}`,
          classes[size]
        )}
      />
    )
  }
)

export default FaIcon
